var _defs, _g, _rect, _polygon, _polygon2, _polygon3, _path, _polygon4, _path2, _polygon5, _rect2, _path3, _polygon6, _path4, _polygon7, _g2, _polygon8, _path5, _path6, _path7, _polygon9, _polygon10, _rect3, _path8, _polygon11, _path9, _polygon12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDias(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 771.56 244.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #dd8026;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fcda00;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #e18e26;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #d62328;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #da5c27;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #fab317;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.89,213.83c0,1.57-1.27,2.85-2.84,2.85s-2.85-1.27-2.85-2.85,1.27-2.85,2.85-2.85,2.84,1.28,2.84,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.08,79.08c0-5.55,4.5-10.06,10.06-10.06s10.05,4.51,10.05,10.06-4.5,10.07-10.05,10.07-10.06-4.51-10.06-10.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.11,99.06c0,2.48-2,4.48-4.47,4.48s-4.48-2-4.48-4.48,2.01-4.49,4.48-4.49,4.47,2.01,4.47,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.7,86.45c0,2.47-2.01,4.48-4.48,4.48s-4.49-2.01-4.49-4.48,2-4.49,4.49-4.49,4.48,2.01,4.48,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.17,75.21c-1.15-2.19-.31-4.9,1.88-6.05,2.18-1.15,4.9-.32,6.06,1.88,1.15,2.19.3,4.91-1.88,6.06-2.18,1.15-4.9.31-6.05-1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.61,99.06c0,3.54-2.87,6.4-6.39,6.4s-6.4-2.86-6.4-6.4,2.86-6.4,6.4-6.4,6.39,2.86,6.39,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.8,234.08c0,4.57-3.7,8.28-8.26,8.28s-8.28-3.71-8.28-8.28,3.72-8.27,8.28-8.27,8.26,3.7,8.26,8.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.91,233.89c0,4.9-3.96,8.87-8.85,8.87s-8.86-3.97-8.86-8.87,3.96-8.87,8.86-8.87,8.85,3.97,8.85,8.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.65,143.58c0,5.56-4.5,10.06-10.06,10.06s-10.06-4.5-10.06-10.06,4.5-10.06,10.06-10.06,10.06,4.51,10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.08,175.71c0-5.56,4.5-10.06,10.05-10.06s10.06,4.51,10.06,10.06-4.5,10.06-10.06,10.06-10.05-4.5-10.05-10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.7,115.2c0,5.55-4.5,10.06-10.06,10.06s-10.06-4.51-10.06-10.06,4.49-10.06,10.06-10.06,10.06,4.51,10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.24,74.77c0-3.76,3.05-6.81,6.8-6.81s6.82,3.05,6.82,6.81-3.05,6.82-6.82,6.82-6.8-3.04-6.8-6.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.75,125.26c0,3.4-2.77,6.16-6.17,6.16s-6.14-2.76-6.14-6.16,2.75-6.16,6.14-6.16,6.17,2.76,6.17,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.39,216.94c0-3.79,3.08-6.87,6.88-6.87s6.85,3.08,6.85,6.87-3.07,6.87-6.85,6.87-6.88-3.08-6.88-6.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,219.15c0-3.79,3.08-6.87,6.86-6.87s6.87,3.08,6.87,6.87-3.08,6.87-6.87,6.87-6.86-3.08-6.86-6.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.39,155.63c0-3.4,2.77-6.16,6.17-6.16s6.15,2.76,6.15,6.16-2.75,6.16-6.15,6.16-6.17-2.75-6.17-6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.13,199.24c0-6.95,5.63-12.59,12.58-12.59s12.59,5.64,12.59,12.59-5.64,12.58-12.59,12.58-12.58-5.63-12.58-12.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.87,163.55c0-3.72,3-6.73,6.71-6.73s6.71,3.01,6.71,6.73-3.01,6.73-6.71,6.73-6.71-3.01-6.71-6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,219.47c0-4.35,3.52-7.88,7.87-7.88s7.89,3.53,7.89,7.88-3.54,7.88-7.89,7.88-7.87-3.52-7.87-7.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.76,217.84c0-2.48,2.01-4.49,4.48-4.49s4.49,2.01,4.49,4.49-2.02,4.48-4.49,4.48-4.48-2-4.48-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.01,236.19c0-3.53,2.86-6.4,6.39-6.4s6.4,2.86,6.4,6.4-2.86,6.4-6.4,6.4-6.39-2.86-6.39-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.2,130.94c0-2.63,2.13-4.75,4.75-4.75s4.75,2.13,4.75,4.75-2.13,4.75-4.75,4.75-4.75-2.12-4.75-4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M6.2,75.43c2.32-1.22,5.19-.33,6.41,1.99,1.22,2.32.33,5.19-1.99,6.41-2.33,1.23-5.19.33-6.42-1.99-1.22-2.32-.33-5.19,2-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.7,98.41c-4.91,2.59-10.99.69-13.58-4.22-2.58-4.92-.7-11.01,4.21-13.59,4.92-2.59,11-.7,13.59,4.22,2.58,4.92.7,11-4.22,13.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.88,219.12c6.94,0,12.58,5.63,12.58,12.59s-5.64,12.6-12.58,12.6-12.58-5.64-12.58-12.6,5.65-12.59,12.58-12.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.01,229.73c-3.67-3.04-4.17-8.48-1.14-12.15,3.04-3.67,8.47-4.18,12.14-1.14,3.68,3.04,4.18,8.47,1.14,12.14-3.03,3.67-8.45,4.18-12.13,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M182.13,242.42c-3.78-3.13-4.31-8.75-1.18-12.54,3.13-3.78,8.75-4.31,12.53-1.18,3.79,3.14,4.32,8.76,1.17,12.54-3.12,3.79-8.74,4.32-12.52,1.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.29,223.25c-1.92-1.57-2.19-4.41-.6-6.32,1.57-1.91,4.4-2.17,6.32-.59,1.9,1.57,2.17,4.4.59,6.32-1.57,1.9-4.4,2.18-6.3.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.52,210.01c-1.91-1.58-2.18-4.41-.59-6.32,1.57-1.91,4.41-2.18,6.31-.6,1.91,1.58,2.18,4.41.6,6.32-1.58,1.91-4.41,2.17-6.32.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.89,240.68c-1.91-1.58-2.18-4.41-.59-6.32,1.58-1.9,4.41-2.17,6.32-.59,1.9,1.57,2.17,4.41.58,6.31-1.57,1.91-4.4,2.17-6.31.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204.71,239.09c-2.24-1.85-2.54-5.15-.69-7.39,1.84-2.23,5.15-2.55,7.38-.69,2.23,1.84,2.54,5.15.69,7.39-1.85,2.23-5.15,2.54-7.37.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.14,148c-1.37,2.23-4.28,2.92-6.5,1.54-2.22-1.37-2.92-4.28-1.54-6.5,1.36-2.22,4.28-2.92,6.5-1.54,2.22,1.37,2.91,4.29,1.54,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.29,170.71c-4.73-2.92-6.2-9.11-3.28-13.84,2.9-4.73,9.1-6.2,13.83-3.29,4.73,2.92,6.2,9.12,3.29,13.84-2.91,4.74-9.11,6.2-13.84,3.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.69,82.32c3.75,2.33,4.93,7.25,2.61,11.01-2.32,3.76-7.25,4.93-11,2.61-3.76-2.32-4.94-7.25-2.61-11,2.31-3.76,7.24-4.93,11-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.21,168.9c4.74,2.91,6.2,9.12,3.29,13.84-2.92,4.73-9.11,6.2-13.85,3.29-4.73-2.92-6.2-9.12-3.28-13.85,2.91-4.73,9.12-6.2,13.84-3.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.95,189.29c2.89,1.79,3.79,5.58,2.01,8.48-1.79,2.9-5.58,3.79-8.47,2.01-2.9-1.78-3.79-5.58-2.02-8.47,1.78-2.9,5.58-3.8,8.48-2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.8,160.32c2.11,1.3,2.77,4.07,1.46,6.17-1.29,2.11-4.05,2.77-6.15,1.46-2.11-1.29-2.77-4.06-1.47-6.17,1.3-2.11,4.06-2.76,6.17-1.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.29,142.71c3,1.86,3.94,5.8,2.08,8.8-1.85,3.01-5.79,3.94-8.8,2.08-3-1.85-3.94-5.79-2.08-8.79,1.86-3.01,5.79-3.95,8.8-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.64,164.33c-2.24-1.38-2.93-4.31-1.56-6.53,1.38-2.24,4.3-2.93,6.54-1.55,2.24,1.38,2.93,4.3,1.55,6.53-1.38,2.23-4.3,2.93-6.53,1.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.4,200.9c-2.9,4.69-9.04,6.16-13.73,3.26-4.7-2.9-6.16-9.06-3.26-13.75,2.89-4.7,9.04-6.16,13.74-3.26,4.69,2.89,6.15,9.05,3.25,13.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.3,227.06c-3.65,5.92-11.39,7.76-17.31,4.12-5.92-3.65-7.77-11.41-4.12-17.32,3.65-5.92,11.4-7.76,17.32-4.11,5.92,3.65,7.75,11.4,4.11,17.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.42,86.92c-3.65,5.92-11.4,7.76-17.32,4.11-5.91-3.65-7.74-11.41-4.09-17.32,3.64-5.92,11.39-7.76,17.31-4.11,5.92,3.65,7.75,11.4,4.11,17.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.82,169.73c-3.64,5.91-11.39,7.76-17.3,4.11-5.92-3.65-7.76-11.4-4.12-17.33,3.65-5.91,11.41-7.76,17.33-4.1,5.91,3.64,7.75,11.39,4.1,17.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.02,207.49c2.63,0,4.76,2.13,4.76,4.75s-2.13,4.75-4.76,4.75-4.75-2.12-4.75-4.75,2.13-4.75,4.75-4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.17,183.01c2.63,0,4.76,2.12,4.76,4.75s-2.13,4.75-4.76,4.75-4.74-2.12-4.74-4.75,2.12-4.75,4.74-4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.06,213.11c2.14,0,3.87,1.73,3.87,3.87s-1.73,3.88-3.87,3.88-3.87-1.73-3.87-3.88,1.73-3.87,3.87-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.4,230.3c0,6.96-5.63,12.59-12.58,12.59s-12.59-5.63-12.59-12.59,5.63-12.59,12.59-12.59,12.58,5.64,12.58,12.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.35,236.03c-5.56,0-10.06-4.51-10.06-10.06s4.5-10.06,10.06-10.06,10.05,4.51,10.05,10.06-4.51,10.06-10.05,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.51,201.76c-5.56,0-10.06-4.51-10.06-10.06s4.5-10.06,10.06-10.06,10.06,4.51,10.06,10.06-4.51,10.06-10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.01,212.24c-3.4,0-6.15-2.76-6.15-6.17s2.75-6.15,6.15-6.15,6.16,2.75,6.16,6.15-2.76,6.17-6.16,6.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.43,77.54c0-5.55,4.51-10.06,10.05-10.06s10.05,4.51,10.05,10.06-4.5,10.06-10.05,10.06-10.05-4.51-10.05-10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.06,119.24c0-3.72,3.01-6.72,6.72-6.72s6.72,3.01,6.72,6.72-3.01,6.72-6.72,6.72-6.72-3.01-6.72-6.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.64,105.09c-3.54,4.28-9.88,4.87-14.16,1.33-4.29-3.54-4.89-9.88-1.34-14.17,3.55-4.28,9.89-4.88,14.17-1.33,4.28,3.55,4.86,9.89,1.33,14.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.84,89.41c-1.64,1.97-4.56,2.25-6.54.62-1.97-1.64-2.25-4.56-.61-6.54,1.64-1.97,4.56-2.25,6.53-.61,1.97,1.64,2.25,4.56.62,6.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.62,76.75c0,5.55-4.5,10.06-10.05,10.06s-10.07-4.51-10.07-10.06,4.51-10.06,10.07-10.06,10.05,4.51,10.05,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.79,116.1c0-5.56,4.5-10.07,10.05-10.07s10.07,4.51,10.07,10.07-4.51,10.06-10.07,10.06-10.05-4.51-10.05-10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.76,106.04c0-3.4,2.75-6.16,6.15-6.16s6.15,2.76,6.15,6.16-2.75,6.16-6.15,6.16-6.15-2.76-6.15-6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.55,129.67c0-3.41,2.75-6.16,6.16-6.16s6.15,2.76,6.15,6.16-2.76,6.16-6.15,6.16-6.16-2.76-6.16-6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.21,139.8c0-3.71,3.01-6.72,6.72-6.72s6.72,3.01,6.72,6.72-3.01,6.73-6.72,6.73-6.72-3.01-6.72-6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.29,100.36c0,2.63-2.12,4.76-4.75,4.76s-4.75-2.12-4.75-4.76,2.12-4.74,4.75-4.74,4.75,2.12,4.75,4.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.3,151.57c0-2.62,2.13-4.75,4.76-4.75s4.75,2.12,4.75,4.75-2.13,4.75-4.75,4.75-4.76-2.12-4.76-4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M187.58,139.67c2.47,0,4.48,2.01,4.48,4.49s-2.01,4.48-4.48,4.48-4.5-2.01-4.5-4.48,2.01-4.49,4.5-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,15.94c-1.37,2.23-4.28,2.92-6.5,1.54-2.22-1.37-2.92-4.28-1.54-6.5,1.36-2.22,4.28-2.92,6.51-1.55,2.22,1.37,2.91,4.29,1.54,6.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.15,38.64c-4.73-2.92-6.2-9.11-3.28-13.84,2.91-4.73,9.1-6.2,13.83-3.29,4.73,2.92,6.21,9.12,3.29,13.85-2.91,4.74-9.1,6.2-13.84,3.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.66,28.26c2.11,1.3,2.76,4.07,1.46,6.17-1.29,2.11-4.06,2.77-6.16,1.46-2.11-1.29-2.78-4.06-1.47-6.17,1.3-2.11,4.06-2.76,6.17-1.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.17.67c2.11,1.3,2.77,4.06,1.46,6.17-1.29,2.11-4.06,2.77-6.15,1.46-2.12-1.29-2.78-4.06-1.47-6.17C4.31.02,7.07-.63,9.17.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.15,10.65c3,1.86,3.93,5.8,2.08,8.8-1.85,3.01-5.79,3.94-8.8,2.08-3-1.86-3.94-5.79-2.08-8.8,1.85-3.01,5.79-3.94,8.8-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.68,37.67c-3.64,5.91-11.39,7.76-17.3,4.11-5.92-3.65-7.76-11.4-4.12-17.32,3.65-5.91,11.4-7.76,17.32-4.11,5.91,3.64,7.75,11.4,4.1,17.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.44,7.61c2.47,0,4.49,2.01,4.49,4.49s-2.02,4.49-4.49,4.49-4.5-2.01-4.5-4.49,2.01-4.49,4.5-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.35,143.33c0,6.98-5.67,12.64-12.63,12.64s-12.64-5.66-12.64-12.64,5.66-12.64,12.64-12.64,12.63,5.66,12.63,12.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.14,100.45c-.25,3.24,2.15,6.08,5.39,6.33,3.24.26,6.07-2.16,6.34-5.4.25-3.23-2.16-6.07-5.4-6.33-3.24-.25-6.07,2.16-6.33,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.08,83.77c-2.4-2.4-6.29-2.42-8.7,0-2.41,2.4-2.41,6.29,0,8.7,2.39,2.41,6.3,2.42,8.7.02,2.4-2.4,2.41-6.3,0-8.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.91,99.2c-2.72-2.26-3.1-6.29-.86-9.01,2.26-2.72,6.29-3.1,9.01-.85,2.72,2.26,3.09,6.29.84,9.01-2.26,2.72-6.28,3.1-9,.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.38,74.17c-2.23-1.85-2.54-5.16-.69-7.38,1.85-2.23,5.15-2.54,7.39-.7,2.23,1.85,2.54,5.16.69,7.4-1.84,2.23-5.15,2.54-7.38.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M395.07,232.19c0,5.56-4.51,10.06-10.06,10.06s-10.06-4.5-10.06-10.06,4.5-10.06,10.06-10.06,10.06,4.51,10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391.49,170.16c0,5.55-4.5,10.07-10.05,10.07s-10.06-4.51-10.06-10.07,4.5-10.07,10.06-10.07,10.05,4.51,10.05,10.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M405.12,203.81c0,5.56-4.5,10.06-10.05,10.06s-10.06-4.5-10.06-10.06,4.51-10.06,10.06-10.06,10.05,4.51,10.05,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M387.17,213.87c0,3.41-2.76,6.16-6.16,6.16s-6.15-2.75-6.15-6.16,2.75-6.16,6.15-6.16,6.16,2.76,6.16,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411.45,235.95c0,3.4-2.76,6.16-6.15,6.16s-6.16-2.76-6.16-6.16,2.76-6.16,6.16-6.16,6.15,2.76,6.15,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M387.17,190.24c0,3.4-2.76,6.16-6.16,6.16s-6.16-2.76-6.16-6.16,2.76-6.15,6.16-6.15,6.16,2.76,6.16,6.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M281.23,214.53c0,3.4-2.75,6.16-6.16,6.16s-6.15-2.76-6.15-6.16,2.76-6.15,6.15-6.15,6.16,2.75,6.16,6.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.07,97.41c0,3.4-2.76,6.16-6.16,6.16s-6.16-2.76-6.16-6.16,2.76-6.16,6.16-6.16,6.16,2.76,6.16,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M405.44,146.63c0,6.95-5.65,12.59-12.59,12.59s-12.58-5.64-12.58-12.59,5.64-12.59,12.58-12.59,12.59,5.63,12.59,12.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.06,148.83c0,6.95-5.63,12.59-12.59,12.59s-12.58-5.64-12.58-12.59,5.64-12.59,12.58-12.59,12.59,5.64,12.59,12.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.16,79.45c0,5.03-4.07,9.1-9.09,9.1s-9.1-4.07-9.1-9.1,4.08-9.1,9.1-9.1,9.09,4.07,9.09,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.68,193c0,6.95-5.63,12.59-12.58,12.59s-12.59-5.64-12.59-12.59,5.63-12.59,12.59-12.59,12.58,5.64,12.58,12.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M434.12,223.91c0,6.95-5.63,12.6-12.58,12.6s-12.59-5.65-12.59-12.6,5.63-12.59,12.59-12.59,12.58,5.63,12.58,12.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.16,103.48c0,5.56-4.51,10.06-10.06,10.06s-10.06-4.5-10.06-10.06,4.51-10.06,10.06-10.06,10.06,4.51,10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.82,160.89c0,5.56-4.51,10.06-10.06,10.06s-10.06-4.51-10.06-10.06,4.51-10.06,10.06-10.06,10.06,4.51,10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M298.43,101.27c0,5.56-4.5,10.06-10.06,10.06s-10.06-4.51-10.06-10.06,4.51-10.06,10.06-10.06,10.06,4.5,10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.57,72.57c0,5.55-4.5,10.07-10.06,10.07s-10.05-4.51-10.05-10.07,4.5-10.06,10.05-10.06,10.06,4.5,10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.57,233.76c0,5.55-4.5,10.06-10.06,10.06s-10.05-4.51-10.05-10.06,4.5-10.06,10.05-10.06,10.06,4.5,10.06,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.06,220.51c0,5.55-4.5,10.06-10.06,10.06s-10.06-4.51-10.06-10.06,4.52-10.07,10.06-10.07,10.06,4.51,10.06,10.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.49,180.11c0,3.72-3,6.72-6.72,6.72s-6.72-3-6.72-6.72,3.01-6.72,6.72-6.72,6.72,3.01,6.72,6.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M383.82,113.55c0,2.48-2,4.48-4.48,4.48s-4.49-2.01-4.49-4.48,2.01-4.49,4.49-4.49,4.48,2.01,4.48,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M310.75,72.57c0,2.48-2.01,4.49-4.49,4.49s-4.48-2.01-4.48-4.49,2-4.48,4.48-4.48,4.49,2.01,4.49,4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391.88,86.64c0,2.9-2.35,5.25-5.24,5.25s-5.25-2.36-5.25-5.25,2.34-5.25,5.25-5.25,5.24,2.35,5.24,5.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M403.34,129.55c0,2.48-2.01,4.49-4.48,4.49s-4.49-2.01-4.49-4.49,2.02-4.48,4.49-4.48,4.48,2,4.48,4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M387.82,129.55c0,3.53-2.86,6.4-6.39,6.4s-6.39-2.87-6.39-6.4,2.86-6.4,6.39-6.4,6.39,2.87,6.39,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M295.94,205.59c0,2.48-2,4.48-4.47,4.48s-4.5-2.01-4.5-4.48,2.01-4.49,4.5-4.49,4.47,2.01,4.47,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M322.08,239.98c0,2.48-2.01,4.48-4.49,4.48s-4.47-2-4.47-4.48,2.01-4.49,4.47-4.49,4.49,2.01,4.49,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M317.58,225.21c0,3.54-2.86,6.4-6.38,6.4s-6.4-2.86-6.4-6.4,2.86-6.4,6.4-6.4,6.38,2.87,6.38,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M344.1,87.05c0,2.48-2.01,4.49-4.49,4.49s-4.49-2.01-4.49-4.49,2.01-4.48,4.49-4.48,4.49,2,4.49,4.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M323.51,140.38c0,3.4-2.76,6.16-6.15,6.16s-6.16-2.76-6.16-6.16,2.75-6.16,6.16-6.16,6.15,2.76,6.15,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M302.17,144.46c0,2.47-2.01,4.48-4.48,4.48s-4.49-2.01-4.49-4.48,2.01-4.49,4.49-4.49,4.48,2.01,4.48,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.92,88.56c0,3.49-2.84,6.34-6.33,6.34s-6.34-2.84-6.34-6.34,2.85-6.33,6.34-6.33,6.33,2.84,6.33,6.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.79,70.35c0,2.48-2.01,4.49-4.48,4.49s-4.48-2.01-4.48-4.49,2.01-4.49,4.48-4.49,4.48,2.01,4.48,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.33,100.85c0,2.48-2.01,4.49-4.48,4.49s-4.49-2.01-4.49-4.49,2.01-4.49,4.49-4.49,4.48,2.01,4.48,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M295.54,83.48c0,3.54-2.86,6.4-6.39,6.4s-6.4-2.86-6.4-6.4,2.86-6.4,6.4-6.4,6.39,2.87,6.39,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M330.59,87.06c0,2.57-2.08,4.64-4.64,4.64s-4.64-2.08-4.64-4.64,2.07-4.64,4.64-4.64,4.64,2.08,4.64,4.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.32,230.93c-4.96,4.23-12.39,3.65-16.61-1.31-4.23-4.95-3.65-12.39,1.3-16.62,4.95-4.22,12.38-3.63,16.62,1.32,4.22,4.95,3.63,12.39-1.31,16.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M273.87,177.11c0,3.4-2.76,6.16-6.15,6.16s-6.16-2.76-6.16-6.16,2.76-6.15,6.16-6.15,6.15,2.75,6.15,6.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M374.52,156.29c0,4.47-3.63,8.12-8.11,8.12s-8.11-3.64-8.11-8.12,3.63-8.12,8.11-8.12,8.11,3.64,8.11,8.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M345.29,161.43c0-3.4,2.76-6.16,6.15-6.16s6.16,2.76,6.16,6.16-2.76,6.16-6.16,6.16-6.15-2.76-6.15-6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.84,203.03c2.59-2.21,6.47-1.91,8.68.68,2.2,2.58,1.9,6.47-.69,8.68-2.59,2.2-6.48,1.9-8.68-.68-2.2-2.58-1.9-6.48.68-8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M347.45,76.22c2.59-2.22,6.46-1.9,8.68.68,2.2,2.58,1.9,6.47-.69,8.68-2.58,2.21-6.48,1.9-8.67-.68-2.2-2.58-1.91-6.47.68-8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295,236.9c0-3.71,3.01-6.72,6.72-6.72s6.72,3.01,6.72,6.72-3.01,6.73-6.72,6.73-6.72-3.01-6.72-6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M295.03,160.11c0-3.71,3-6.71,6.72-6.71s6.72,3,6.72,6.71-3.01,6.72-6.72,6.72-6.72-3.01-6.72-6.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M373.69,221.41c-1.55,1.32-3.89,1.14-5.21-.41-1.32-1.56-1.14-3.89.4-5.21,1.56-1.32,3.89-1.14,5.22.41,1.32,1.55,1.14,3.88-.41,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.22,153.42c0,2.48-2.01,4.49-4.48,4.49s-4.48-2.01-4.48-4.49,2-4.49,4.48-4.49,4.48,2.01,4.48,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M296.15,173.3c0,2.48-2.01,4.48-4.48,4.48s-4.48-2-4.48-4.48,2.01-4.49,4.48-4.49,4.48,2.01,4.48,4.49"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 436.53,
    y: 63.79,
    width: 3.97,
    height: 22.66
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "468.07 86.45 456.25 70.28 456.25 86.45 452.28 86.45 452.28 63.79 456.35 63.79 467.93 79.52 467.93 63.79 471.91 63.79 471.91 86.45 468.07 86.45"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "488.52 86.45 488.52 67.28 481.66 67.28 481.66 63.79 499.35 63.79 499.35 67.28 492.5 67.28 492.5 86.45 488.52 86.45"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "509.09 86.45 509.09 63.79 524.61 63.79 524.61 67.28 513.06 67.28 513.06 73.16 524.37 73.16 524.37 76.66 513.06 76.66 513.06 82.95 524.61 82.95 524.61 86.45 509.09 86.45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M549.08,70.89c0-2.17-1.63-3.6-3.87-3.6h-5.43v7.2h5.43c2.24,0,3.87-1.43,3.87-3.6M548.74,86.45l-5.02-8.46h-3.94v8.46h-3.97v-22.66h9.95c4.48,0,7.4,2.92,7.4,7.1s-2.65,6.22-5.37,6.66l5.54,8.9h-4.58Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "579.75 86.45 567.93 70.28 567.93 86.45 563.96 86.45 563.96 63.79 568.03 63.79 579.61 79.52 579.61 63.79 583.58 63.79 583.58 86.45 579.75 86.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M604.27,67.8l-4.07,10.8h8.15l-4.07-10.8ZM611.12,86.45l-1.66-4.35h-10.39l-1.67,4.35h-4.51l8.89-22.66h4.96l8.9,22.66h-4.52Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "627.6 86.45 627.6 67.28 620.74 67.28 620.74 63.79 638.43 63.79 638.43 67.28 631.57 67.28 631.57 86.45 627.6 86.45"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 648.17,
    y: 63.79,
    width: 3.97,
    height: 22.66
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M681.85,75.13c0-4.69-2.96-8.19-7.5-8.19s-7.51,3.5-7.51,8.19,2.92,8.19,7.51,8.19,7.5-3.53,7.5-8.19M662.77,75.13c0-6.76,4.79-11.72,11.58-11.72s11.57,4.96,11.57,11.72-4.78,11.72-11.57,11.72-11.58-4.95-11.58-11.72"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "712.39 86.45 700.57 70.28 700.57 86.45 696.6 86.45 696.6 63.79 700.67 63.79 712.25 79.52 712.25 63.79 716.22 63.79 716.22 86.45 712.39 86.45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M736.91,67.8l-4.08,10.8h8.15l-4.07-10.8ZM743.76,86.45l-1.66-4.35h-10.38l-1.67,4.35h-4.51l8.89-22.66h4.96l8.89,22.66h-4.51Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "757.6 63.79 757.6 86.45 771.56 86.45 771.56 82.95 761.58 82.95 761.58 63.79 757.6 63.79"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M435.08,113.85l2.21-3.06c1.56,1.67,4,3.13,7.16,3.13s4.55-1.6,4.55-3.09c0-4.76-13.21-1.8-13.21-10.16,0-3.73,3.29-6.62,8.25-6.62,3.54,0,6.39,1.13,8.49,3.16l-2.28,2.96c-1.77-1.77-4.17-2.58-6.55-2.58s-3.84,1.12-3.84,2.82c0,4.22,13.18,1.6,13.18,10.06,0,3.77-2.65,7-8.76,7-4.18,0-7.2-1.46-9.2-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.32,105.73c0-4.69-2.96-8.19-7.51-8.19s-7.5,3.5-7.5,8.19,2.92,8.19,7.5,8.19,7.51-3.53,7.51-8.19M462.23,105.73c0-6.76,4.79-11.72,11.58-11.72s11.58,4.96,11.58,11.72-4.79,11.72-11.58,11.72-11.58-4.96-11.58-11.72"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "496.06 117.05 496.06 94.39 500.04 94.39 500.04 113.54 510.02 113.54 510.02 117.05 496.06 117.05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M530.08,98.39l-4.08,10.81h8.15l-4.07-10.81ZM536.93,117.04l-1.66-4.35h-10.38l-1.67,4.35h-4.51l8.9-22.65h4.95l8.9,22.65h-4.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M564.05,101.49c0-2.17-1.63-3.6-3.86-3.6h-5.44v7.2h5.44c2.24,0,3.86-1.43,3.86-3.6M563.71,117.05l-5.02-8.46h-3.94v8.46h-3.97v-22.66h9.95c4.48,0,7.4,2.92,7.4,7.1s-2.65,6.22-5.37,6.66l5.54,8.9h-4.58Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M445.53,129l-4.07,10.8h8.15l-4.07-10.8ZM452.39,147.65l-1.66-4.35h-10.39l-1.67,4.35h-4.51l8.9-22.66h4.95l8.9,22.66h-4.51Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "466.23 147.65 466.23 124.99 470.21 124.99 470.21 144.14 480.19 144.14 480.19 147.65 466.23 147.65"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "490.04 147.65 490.04 124.99 494.02 124.99 494.02 144.14 504 144.14 504 147.65 490.04 147.65"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 513.86,
    y: 124.99,
    width: 3.97,
    height: 22.66
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M538.45,129l-4.07,10.8h8.15l-4.07-10.8ZM545.31,147.65l-1.66-4.35h-10.39l-1.66,4.35h-4.52l8.89-22.66h4.96l8.89,22.66h-4.51Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "574.94 147.65 563.13 131.48 563.13 147.65 559.15 147.65 559.15 124.99 563.23 124.99 574.8 140.71 574.8 124.99 578.78 124.99 578.78 147.65 574.94 147.65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M589.41,136.33c0-6.97,5.19-11.72,11.88-11.72,4.58,0,7.4,2.38,9.1,5.1l-3.4,1.73c-1.09-1.87-3.26-3.29-5.7-3.29-4.48,0-7.81,3.43-7.81,8.19s3.33,8.19,7.81,8.19c2.44,0,4.61-1.39,5.7-3.29l3.4,1.73c-1.73,2.72-4.51,5.09-9.1,5.09-6.69,0-11.88-4.76-11.88-11.72"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "620.43 147.65 620.43 124.99 635.94 124.99 635.94 128.49 624.4 128.49 624.4 134.36 635.71 134.36 635.71 137.86 624.4 137.86 624.4 144.14 635.94 144.14 635.94 147.65 620.43 147.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDias);
export default __webpack_public_path__ + "static/media/logoDIAS.b7856f5c9e432578e49358163293ee25.svg";
export { ForwardRef as ReactComponent };